import { Flex } from 'antd';
import React from 'react';

interface ProductSubmitButtonProps {
  handleSubmit: () => void;
  buttonIcon: React.ElementType;
  isPrimaryButton?: boolean;
  disableButton?: boolean;
}

const ProductSubmitButton: React.FC<ProductSubmitButtonProps> = ({
  buttonIcon: ButtonIcon,
  isPrimaryButton,
  disableButton,
  handleSubmit,
}) => {
  if (isPrimaryButton) {
    return (
      <Flex
        className='product-submit-btn is-primary-btn border border-sd-primary bg-sd-primary rounded-md flex justify-center items-center'
        onClick={handleSubmit}
        style={{ cursor: disableButton ? 'not-allowed' : 'pointer' }}
      >
        <ButtonIcon className='text-sd-primary-foreground' width={24} height={24} />
      </Flex>
    );
  }

  return (
    <button
      type='button'
      onClick={handleSubmit}
      className='product-submit-btn is-delete-btn shrink-0 h-9 w-9 flex items-center justify-center rounded-md border border-sd-input bg-sd-background text-sd-destructive hover:text-sd-destructive hover:bg-sd-destructive/10 hover:border-sd-destructive/30 transition-colors cursor-pointer'
      style={{ cursor: disableButton ? 'not-allowed' : 'pointer' }}
    >
      <ButtonIcon width={16} height={16} strokeWidth={1.5} />
    </button>
  );
};

export default ProductSubmitButton;
